import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { db } from "../../firebase";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { AccountBalance, Add, Done, Error, Refresh } from "@mui/icons-material";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import { Divider } from "@mui/material";
import saved from "../../assets/sound/saved.wav";
import InvForm from "./InvForm";
import MainForm from "./MainForm";
import MoveForm from "./MoveForm";
import BankForm from "../register/BankForm";
import ProductChart from "./ProductChart";
const ref = collection(db, "products");

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const styleMove = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 560,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Inventory = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [openMain, setOpenMain] = useState(false);
  const [openMove, setOpenMove] = useState(false);
  const [openBank, setOpenBank] = useState(false);
  const [openChart, setOpeChart] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setOpenNew(false);
    setOpenMain(false);
    setOpenMove(false);
    setOpenBank(false);
    setOpeChart(false);
  };
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [id, SetId] = useState("");
  const [title, setTitle] = useState("");
  const [barCode, setBarCode] = useState("");
  const [alterName, setAlterName] = useState("");
  const [url, SetUrl] = useState("");
  const [category, setCategory] = useState("");
  const [store, setStore] = useState("");
  const [van, setVan] = useState("");
  const [web, setWeb] = useState("");
  const [amazon, setAmazon] = useState("");
  const [cost, setCost] = useState("");
  const [price, setPrice] = useState("");
  const [locationA, setLocationA] = useState("");
  const [locationB, setLocationB] = useState("");

  const [location, setLocation] = useState("store");
  const [date, setDate] = useState("");
  const [user, setUser] = useState("");
  const [cash, setCash] = useState(0);
  const [cashApp, setCashApp] = useState(0);
  const [zelle, setZelle] = useState(0);
  const [card, setCard] = useState(0);
  const [other, setOther] = useState(0);
  const [expense, setExpense] = useState(0);
  const [description, setDescription] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const data = await getDocs(ref);
      setData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      setLoading(false);
    };

    fetchData();
  }, []);

  const ModalFunc = (params) => {
    setOpenMain(true);
    SetId(params[0]);
    setTitle(params[1]);
    setBarCode(params[10]);
    setAlterName(params[8]);
    SetUrl(params[12]);
    setCategory(params[9]);
    setPrice(params[2]);
    setCost(params[11]);
    setStore(params[3]);
    setVan(params[4]);
    setWeb(params[5]);
    setAmazon(params[6]);
  };

  const handleModalAdd = () => {
    setTitle("");
    setAlterName("");
    setCategory("");
    setStore(0);
    setVan(0);
    setWeb(0);
    setAmazon(0);
    setBarCode("");
    setPrice(0);
    setCost(0);
    SetUrl("");
    setOpenNew(true);
  };

  const handleEdit = () => {
    setOpen(true);
  };
  const handleCart = () => {};
  const handleMove = () => {
    setOpenMain(false);
    setOpenMove(true);
  };
  const handleNewRecord = async () => {
    const userCollectionRef = collection(db, "products");
    const total = Number(store) + Number(van) + Number(web) + Number(amazon);
    await addDoc(userCollectionRef, {
      title: title,
      stock_store: store,
      stock_van: van,
      alterName: alterName,
      stock_var1: web,
      stock_var2: amazon,
      stock_all: total,
      url_location: url,
      price: price,
      cost: cost,
      category: category,
      barCode: barCode,
    });
    setOpenNew(false);
  };

  const handleUpdate = async () => {
    new Audio(saved).play();
    const userDoc = doc(db, "products", id);
    const total = Number(store) + Number(van) + Number(web) + Number(amazon);
    const newFields = {
      title: title,
      stock_store: store,
      stock_van: van,
      stock_var1: web,
      stock_var2: amazon,
      stock_all: total,
      url_location: url,
      price: price,
      cost: cost,
      category: category,
      barCode: barCode,
    };
    await updateDoc(userDoc, newFields);

    window.location.reload();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleBank = () => {
    setOpenBank(true);
  };

  const handleChart = () => {
    setOpeChart(true);

    setOpenMain(false);
  };

  const AddButton = () => (
    <>
      <Tooltip disableFocusListener title="Add new Record">
        <IconButton onClick={handleModalAdd}>
          <Add />
        </IconButton>
      </Tooltip>
      <Tooltip disableFocusListener title="Add new Record">
        <IconButton onClick={handleRefresh}>
          <Refresh />
        </IconButton>
      </Tooltip>
      <Tooltip disableFocusListener title="Add new Register">
        <IconButton onClick={handleBank}>
          <AccountBalance />
        </IconButton>
      </Tooltip>
    </>
  );
  const columns = [
    {
      name: "id", // 0
      label: "id",
      options: {
        display: false,
      },
    },
    {
      name: "title", // 1
      label: "Title",
    },
    {
      name: "price", // 2
      label: "price",
    },
    {
      name: "stock_store", // 3
      label: "Store",
      id: "store",
    },
    {
      name: "stock_van", // 4
      label: "Van",
      id: "van",
    },
    {
      name: "stock_var1", // 5
      label: "Web",
      id: "web",
    },
    {
      name: "stock_var2", // 6
      label: "Amaz",
      id: "amazon",
    },
    {
      name: "stock_var2", // 7
      label: "Amaz",
      options: {
        display: false,
      },
    },
    {
      name: "alterName", // 8
      label: "alterName",
      options: {
        display: false,
      },
    },
    {
      name: "category", // 9
      label: "category",
      options: {
        display: false,
      },
    },
    {
      name: "barCode", // 10
      label: "barCode",
      options: {
        display: false,
      },
    },
    {
      name: "cost", // 11
      label: "cost",
      options: {
        display: false,
      },
    },
    {
      name: "url_location", // 12
      label: "Location",
      options: {
        display: false,
      },
    },

    {
      name: "?",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = tableMeta.rowData;
          const total =
            Number(row[3]) + Number(row[4]) + Number(row[5]) + Number(row[6]);

          if (total >= 1)
            return (
              <Tooltip title="OK">
                <Done color="primary" />
              </Tooltip>
            );
          else
            return (
              <Tooltip title="Failing">
                <Error color="error" />
              </Tooltip>
            );
        },
      },
    },

    // Add more columns as needed
  ];

  const options = {
    customToolbar: AddButton,
    selectableRowsHideCheckboxes: true,
    onRowClick: (rowData) => {
      ModalFunc(rowData);
    },
    sortOrder: {
      name: "title",
      direction: "asc",
    },
  };

  return (
    <>
      {/* =====  MAIN MODAL ============ */}
      <Modal keepMounted open={openMain} onClose={handleClose}>
        <Box sx={style}>
          <MainForm
            title={title}
            barCode={barCode}
            url={url}
            count={count}
            setCount={setCount}
            handleEdit={handleEdit}
            handleMove={handleMove}
            handleCart={handleCart}
            handleChart={handleChart}
          />
        </Box>
      </Modal>

      {/* =====  MOVE MODAL ============ */}
      <Modal keepMounted open={openMove} onClose={handleClose}>
        <Box sx={styleMove}>
          <MoveForm
            id={id}
            title={title}
            store={store}
            van={van}
            web={web}
            amazon={amazon}
            locationA={locationA}
            locationB={locationB}
            locationAset={setLocationA}
            locationBset={setLocationB}
            setOpenMove={setOpenMove}
            count={count}
          />
        </Box>
      </Modal>

      {/* =====  CHART MODAL ============ */}
      <Modal keepMounted open={openChart} onClose={handleClose}>
        <Box sx={styleMove}>
          <ProductChart id={id} title={title} setOpeChart={setOpeChart} />
        </Box>
      </Modal>

      {/* ===== UPDATE RECORD ============ */}
      <Modal keepMounted open={open} onClose={handleClose}>
        <Box sx={style}>
          <Divider />
          <InvForm
            id={id}
            title={title}
            setTitle={setTitle}
            store={store}
            setStore={setStore}
            van={van}
            setVan={setVan}
            web={web}
            setWeb={setWeb}
            amazon={amazon}
            setAmazon={setAmazon}
            handleOnSubmit={handleUpdate}
            buttonTitle={"Update Record"}
          />
        </Box>
      </Modal>

      {/* ===== NEW RECORD ============ */}
      <Modal keepMounted open={openNew} onClose={handleClose}>
        <Box sx={style}>
          <Divider />
          <InvForm
            title={title}
            setTitle={setTitle}
            alterName={alterName}
            setAlterName={setAlterName}
            category={category}
            setCategory={setCategory}
            barCode={barCode}
            setBarCode={setBarCode}
            store={store}
            setStore={setStore}
            van={van}
            setVan={setVan}
            web={web}
            setWeb={setWeb}
            amazon={amazon}
            setAmazon={setAmazon}
            price={price}
            setPrice={setPrice}
            cost={cost}
            setCost={setCost}
            url={url}
            SetUrl={SetUrl}
            handleOnSubmit={handleNewRecord}
            buttonTitle={"Save New Record"}
          />
        </Box>
      </Modal>

      {/* ===== BANK NEW RECORD MODAL ============ */}
      <Modal keepMounted open={openBank} onClose={handleClose}>
        <Box sx={styleMove}>
          <Divider />
          <BankForm
            cash={cash}
            setCash={setCash}
            cashApp={cashApp}
            setCashApp={setCashApp}
            zelle={zelle}
            setZelle={setZelle}
            card={card}
            setCard={setCard}
            other={other}
            setOther={setOther}
            expense={expense}
            setExpense={setExpense}
            description={description}
            setDescription={setDescription}
            location={location}
            setLocation={setLocation}
            user={user}
            setUser={setUser}
            date={date}
            setDate={setDate}
            operation="new"
            textButton="SAVE NEW RECORD"
            setOpenBank={setOpenBank}
          />
        </Box>
      </Modal>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "45vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <MUIDataTable
          title="Inventory"
          columns={columns}
          options={options}
          data={data}
          checkboxSelection
        />
      )}
    </>
  );
};
export default Inventory;
